import { render } from "./AmbulanceComponent.vue?vue&type=template&id=af1f8280"
import script from "./AmbulanceComponent.vue?vue&type=script&lang=js"
export * from "./AmbulanceComponent.vue?vue&type=script&lang=js"

import "./AmbulanceComponent.vue?vue&type=style&index=0&id=af1f8280&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__